import React from 'react';

import { FlexColumn } from 'ui-components/components/flex';

import type { TransferOrderResponse } from '../../../api/transfer-order-api';
import { ShippingDetails } from '../shipping-details/shipping-details';
import { ShippingDetailsEdit, type ShippingDetailsEditFormData } from '../shipping-details-edit/shipping-details-edit';
import { TransferDetails } from '../transfer-details/transfer-details';
import { TransferredProducts } from '../transferred-products/transferred-products';
import styles from './transfer-order-details.styles.module.less';

type TransferOrderDetailsProps = {
  transferOrder: TransferOrderResponse;
  originWarehouseName: string;
  destinationWarehouseName: string;
  isEditMode: boolean;
  onShippingFormDataChange: (updates: Partial<ShippingDetailsEditFormData>) => void;
};

export const TransferOrderDetails = ({
  transferOrder,
  originWarehouseName,
  destinationWarehouseName,
  isEditMode,
  onShippingFormDataChange,
}: TransferOrderDetailsProps) => {
  return (
    <div className={styles['transfer-order-details']}>
      <FlexColumn className={styles['transfer-order-details-container']}>
        <TransferDetails destinationWarehouseName={destinationWarehouseName} originWarehouseName={originWarehouseName} />
        {isEditMode ? (
          <ShippingDetailsEdit
            expectedDeliveryDate={transferOrder.expectedDeliveryDate}
            notes={transferOrder.notes}
            onFormDataChange={onShippingFormDataChange}
            orderDate={transferOrder.orderDate}
            orderNumber={transferOrder.orderNumber}
            referenceNumber={transferOrder.referenceNumber}
          />
        ) : (
          <ShippingDetails
            expectedDeliveryDate={transferOrder.expectedDeliveryDate}
            notes={transferOrder.notes}
            orderDate={transferOrder.orderDate}
            orderNumber={transferOrder.orderNumber}
            referenceNumber={transferOrder.referenceNumber}
          />
        )}
        <TransferredProducts products={transferOrder.products ?? []} />
      </FlexColumn>
    </div>
  );
};
